module.exports = __webpack_public_path__ + "img/fantasy-flight-games.d70ea14f.svg";